import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import sys from './modules/sys'
import tags from './modules/tagsView'
import app from './modules/app'
import settings from './modules/settings'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    // isMB: window.screen.width < 480,
    isMB: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
    mainColor: false
  },
  mutations: {
    toSetColor(state, color) {
      state.mainColor = color
    },
  },
  actions: {
  },
  modules: {
    user,
    sys,
    tags,
    app,
    settings
  }
})

export default store;
